import {ReactNode, CSSProperties} from 'react'
import {BRAND} from './site'

export const Container: React.FC<{children: ReactNode; style?: CSSProperties}> = ({children, style}) => (
  <div style={{maxWidth: 1140, margin: '0 auto', padding: '0 20px', ...style}}>{children}</div>
)

/** Slim green banner used at the top of inner guest pages. */
export const PageHero: React.FC<{title: string; sub?: string}> = ({title, sub}) => (
  <section style={{background: `linear-gradient(135deg, #013d1f 0%, ${BRAND.green} 60%, #05b34d 100%)`, color: '#fff'}}>
    <Container style={{padding: '56px 20px 60px', textAlign: 'center'}}>
      <h1 style={{color: '#fff', fontSize: 38, fontWeight: 800, margin: 0}}>{title}</h1>
      {sub && <p style={{fontSize: 17, opacity: 0.95, margin: '12px auto 0', maxWidth: 640}}>{sub}</p>}
    </Container>
  </section>
)

/**
 * Privacy-preserving location map. The exact building is withheld until a renter
 * is approved and has paid, so this centers on the general neighborhood (zoomed
 * out) and overlays a translucent ~2-mile circle instead of dropping an exact
 * pin. `query` must be a neighborhood/area — never a street address.
 */
export const AreaMap: React.FC<{query: string; height?: number}> = ({query, height = 380}) => (
  <div>
    <div style={{position: 'relative', borderRadius: 18, overflow: 'hidden', border: '1px solid #eef0f4', boxShadow: '0 10px 30px rgba(27,27,41,0.06)'}}>
      <iframe
        title='Approximate area'
        src={`https://www.google.com/maps?q=${encodeURIComponent(query)}&z=13&output=embed`}
        width='100%'
        height={height}
        style={{border: 0, display: 'block'}}
        loading='lazy'
        referrerPolicy='no-referrer-when-downgrade'
      />
      {/* Translucent ~2-mile radius circle — communicates a general area, not an
          exact location. pointer-events: none so the map underneath stays pannable. */}
      <div
        aria-hidden
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 250,
          height: 250,
          borderRadius: '50%',
          background: 'rgba(3,149,64,0.13)',
          border: '2px solid rgba(3,149,64,0.55)',
          pointerEvents: 'none',
        }}
      />
      <div style={{position: 'absolute', left: 12, bottom: 12, background: 'rgba(255,255,255,0.92)', borderRadius: 8, padding: '6px 10px', fontSize: 12, fontWeight: 600, color: BRAND.ink, pointerEvents: 'none'}}>
        Approximate area · exact address shared with approved renters
      </div>
    </div>
    <a
      href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`}
      target='_blank'
      rel='noopener noreferrer'
      style={{display: 'inline-block', marginTop: 14, color: BRAND.green, fontWeight: 600, fontSize: 14, textDecoration: 'none'}}
    >
      Open area in Google Maps →
    </a>
  </div>
)
